export const BASE_URL = 'https://api-proshop-ug52.onrender.com';

// ============================== PRODUCTS ==============================
export const PRODUCTS_URL = `${BASE_URL}/products`;

// ============================== USERS ==============================
export const USERS_URL = `${BASE_URL}/users`;

// ============================== ORDERS ==============================
export const ORDERS_URL = `${BASE_URL}/orders`;

// ============================== PAYPAL ==============================
export const PAYPAL_URL = `${BASE_URL}/config/paypal`;

// ============================== UPLOAD ==============================
export const UPLOAD_URL = `${BASE_URL}/upload`;
